import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import WpButton from 'Wpds/components/button/WpButton';
import { advanceOnboardingStateAction } from 'Shared/actions/onboardingState';
import WpIcon from 'Wpds/components/icon/WpIcon';

import ConnectCalendarButtons from '../../DesktopOnboardingWizard/ConnectCalendar/ConnectCalendarButtons/ConnectCalendarButtons';
import './ConnectCalendar.scss';
import SignUpTermsAgreement from 'Shared/components/SignUpTermsAgreement/SignUpTermsAgreement';

const img = 'https://piprodperformassets.blob.core.windows.net/assets/charma_add_to_calendar.png';
const advantages = ['Sync your calendar to get more workspace features for the meetings you choose'];

type Props = {
  userCreatedInMiddle: boolean;
  cannotSignIntoGoogle: boolean;
};

function ConnectCalendar({ userCreatedInMiddle, cannotSignIntoGoogle }: Props) {
  const dispatch = useDispatch();

  const handleSkipClick = useCallback(() => dispatch(advanceOnboardingStateAction({ didSkip: true })), [dispatch]);

  return (
    <div className="MobileConnectCalendar d-flex flex-column align-items-center pt-4">
      <div className="MobileConnectCalendar__title">Sign up with Calendar</div>
      <div className="p-4 d-flex flex-column align-items-center">
        <img className="mb-4" src={img} alt={img} width="200px" />
        {advantages.map(advantage => (
          <div key={advantage} className="MobileConnectCalendar__advantage d-flex mt-3">
            <div className="MobileConnectCalendar__advantage__icon mr-2">
              <WpIcon name="check" />
            </div>
            {advantage}
          </div>
        ))}
      </div>
      <div className="profile-form-content d-flex flex-column w-100">
        {userCreatedInMiddle ? (
          <>
            <div className="create-account-form-area-title mt-lg-5">You already connected your Calendar</div>
            <p />
            <WpButton variant="primary" size="lg" onClick={handleSkipClick}>
              Return
            </WpButton>
          </>
        ) : (
          <>
            <ConnectCalendarButtons cannotSignIntoGoogle={cannotSignIntoGoogle} />
            <p />
            <WpButton
              size={cannotSignIntoGoogle ? 'lg' : 'md'}
              variant={cannotSignIntoGoogle ? 'secondary' : 'tertiary'}
              onClick={handleSkipClick}
            >
              Not now
            </WpButton>
          </>
        )}
      </div>
      {!userCreatedInMiddle && (
        <SignUpTermsAgreement
          prefixText="By connecting calendar"
          className="MobileConnectCalendar__terms text-center px-1 mt-4 pb-3"
        />
      )}
    </div>
  );
}

export default ConnectCalendar;
